<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C9ikEy/tc-custom/9780268103569.jpg?1725149328382" alt="This image is the cover for the book Can Different Cultures Think the Same Thoughts?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Can Different Cultures Think the Same Thoughts?
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A welcome contribution to the burgeoning multicultural revolution in philosophy . . . persuasively shows that ethics cannot be innocent of metaphysics.” —Bryan W. Van Norden, author of <i>Introduction to Classical Chinese Philosophy</i></b><br/>  <br/> Kenneth Dorter’s <i>Can Different Cultures Think the Same Thoughts?</i> is a study of fundamental issues in metaphysics and ethics across major philosophical traditions of the world, including the way in which metaphysics can be a foundation for ethics, as well as the importance of metaphysics on its own terms. Dorter examines such questions through a detailed comparison of selected major thinkers and classic works in three global philosophical traditions, those of India, China, and the West.<br/>  <br/> In each chapter Dorter juxtaposes and compares two or more philosophers or classic works from different traditions, from Spinoza and Shankara, to Confucius and Plato, to Marcus Aurelius and the Bhagavad Gita. In doing so he explores different perspectives and reveals limitations and assumptions that might otherwise be obscure.<br/>  <br/> The goal of Dorter’s cross-cultural approach is to consider how far works from different cultures can be understood as holding comparable philosophical views. Although Dorter reveals commonalities across the different traditions, he makes no claim that there is such a thing as a universal philosophy. Clearly there are fundamental disagreements among the philosophers and works studied. Yet in each of the case studies of a particular chapter, we can discover a shared, or at least analogous, way of looking at issues across different cultures. All those interested in metaphysics, ethics, Indian philosophy, Chinese philosophy, and comparative philosophy will find much of interest in this book.<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Dorter
      </h2>
      
      <p class="authorDescription body article"><P>Kenneth Dorter is a professor of philosophy at the University of Guelph. He has published three books on Plato and has written on various areas of philosophy.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Notre Dame Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c89c6aae